'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withModal = exports.ModalProvider = exports.Provider = exports.ConfirmModal = exports.AlertModal = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsxFileName = 'src/index.js';

var _templateObject = _taggedTemplateLiteral(['\n  .alert__model__container {\n      width: 512px;\n      \n      top: 50%;\n      left: 50%;\n      position: absolute;\n      margin-left: -256px;\n      margin-top: -100px;\n      \n      @media(max-width: 512px) {\n        width: 100%;\n        margin-left: -50%;\n        margin-top: -100px;\n      }\n      \n      display: flex;\n      flex-direction: row;\n      justify-content: center;\n      align-items: center;\n      border-radius: 2px;\n      background-color: ', ';\n      border:  ', ';\n      color: ', ';\n      \n      &.admin{\n        height: 200px;\n        margin-top: -100px;\n        padding: 26px;\n        .alert__model__title{ \n        }\n        .alert__model__content{\n         color: #cccccc;\n        \n        }\n        .alert__model__close__icon{\n          width: 15px;\n          height: 15px;\n          right: 15px;\n          top: 8px;\n          cursor: pointer;\n          display: block;\n          img {width: 100%;height: 100%;}\n          svg{\n            font-size: 15px;\n            position: absolute;\n            top:-0.5px;\n            right: 1.5px;\n            color: rgba(255, 255, 255, 0.31);\n          }\n        }\n      }\n      &.ci{\n        height: 200px;\n        margin-top: -100px;\n        padding: 26px;\n        .alert__model__close__icon{\n          display: block;\n          width: 15px;\n          height: 15px;\n          right: 15px;\n          top: 8px;\n          cursor: pointer;\n          img {width: 100%;height: 100%;}\n          svg{\n            font-size: 15px;\n            position: absolute;\n            top:-0.5px;\n            right: 1.5px;\n          }\n        }\n      }\n  }\n  \n  .alert__model__title {\n    font-size: 21px;\n    text-align: center;\n  }\n  \n  .alert__model__content {\n    font-size: 16px;\n    text-align: center;\n    font-weight: 200;\n  }\n  \n  .alert__model__close__icon {\n    position: absolute;\n    right: 14px;\n    top: 14px;\n    color: gray;\n  }\n'], ['\n  .alert__model__container {\n      width: 512px;\n      \n      top: 50%;\n      left: 50%;\n      position: absolute;\n      margin-left: -256px;\n      margin-top: -100px;\n      \n      @media(max-width: 512px) {\n        width: 100%;\n        margin-left: -50%;\n        margin-top: -100px;\n      }\n      \n      display: flex;\n      flex-direction: row;\n      justify-content: center;\n      align-items: center;\n      border-radius: 2px;\n      background-color: ', ';\n      border:  ', ';\n      color: ', ';\n      \n      &.admin{\n        height: 200px;\n        margin-top: -100px;\n        padding: 26px;\n        .alert__model__title{ \n        }\n        .alert__model__content{\n         color: #cccccc;\n        \n        }\n        .alert__model__close__icon{\n          width: 15px;\n          height: 15px;\n          right: 15px;\n          top: 8px;\n          cursor: pointer;\n          display: block;\n          img {width: 100%;height: 100%;}\n          svg{\n            font-size: 15px;\n            position: absolute;\n            top:-0.5px;\n            right: 1.5px;\n            color: rgba(255, 255, 255, 0.31);\n          }\n        }\n      }\n      &.ci{\n        height: 200px;\n        margin-top: -100px;\n        padding: 26px;\n        .alert__model__close__icon{\n          display: block;\n          width: 15px;\n          height: 15px;\n          right: 15px;\n          top: 8px;\n          cursor: pointer;\n          img {width: 100%;height: 100%;}\n          svg{\n            font-size: 15px;\n            position: absolute;\n            top:-0.5px;\n            right: 1.5px;\n          }\n        }\n      }\n  }\n  \n  .alert__model__title {\n    font-size: 21px;\n    text-align: center;\n  }\n  \n  .alert__model__content {\n    font-size: 16px;\n    text-align: center;\n    font-weight: 200;\n  }\n  \n  .alert__model__close__icon {\n    position: absolute;\n    right: 14px;\n    top: 14px;\n    color: gray;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  .alert__model__container {\n      width: 512px;\n      display: flex;\n      flex-direction: row;\n      justify-content: center;\n      align-items: center;\n      border-radius: 2px;\n      background-color: ', ';\n      border:  ', ';\n      color: ', ';\n      \n      top: 50%;\n      left: 50%;\n      position: absolute;\n      margin-left: -256px;\n      margin-top: -100px;\n      \n      \n      \n      &.admin{\n        height: 200px;\n        margin-top: -100px;\n        padding: 26px;\n        .alert__model__title{ \n        }\n        .alert__model__content{\n         color: #cccccc;\n        \n        }\n        .alert__model__close__icon{\n          width: 15px;\n          height: 15px;\n          right: 15px;\n          top: 8px;\n          cursor: pointer;\n          display: block;\n          img {width: 100%;height: 100%;}\n          svg{\n            font-size: 15px;\n            position: absolute;\n            top:-0.5px;\n            right: 1.5px;\n            color: rgba(255, 255, 255, 0.31);\n          }\n        }\n      }\n      &.ci{\n        height: 200px;\n        margin-top: -100px;\n        padding: 26px;\n        .alert__model__close__icon{\n          display: block;\n          width: 15px;\n          height: 15px;\n          right: 15px;\n          top: 8px;\n          cursor: pointer;\n          img {width: 100%;height: 100%;}\n          svg{\n            font-size: 15px;\n            position: absolute;\n            top:-0.5px;\n            right: 1.5px;\n          }\n        }\n      }\n  }\n  \n  .alert__model__title {\n    font-size: 21px;\n    text-align: center;\n  }\n  \n  .alert__model__content {\n    font-size: 16px;\n    text-align: center;\n    font-weight: 200;\n  }\n  \n  .alert__model__close__icon {\n    position: absolute;\n    right: 14px;\n    top: 14px;\n    color: gray;\n  }\n  \n  .confirm__model__actions {\n    text-align: center;\n    \n    > button {\n      margin: 0 5px -5px 5px;\n      background-color: transparent;\n      border: 1px ', ' solid;\n      color: ', ';\n      cursor: pointer;\n      padding: 3px 15px;\n    }\n  }\n'], ['\n  .alert__model__container {\n      width: 512px;\n      display: flex;\n      flex-direction: row;\n      justify-content: center;\n      align-items: center;\n      border-radius: 2px;\n      background-color: ', ';\n      border:  ', ';\n      color: ', ';\n      \n      top: 50%;\n      left: 50%;\n      position: absolute;\n      margin-left: -256px;\n      margin-top: -100px;\n      \n      \n      \n      &.admin{\n        height: 200px;\n        margin-top: -100px;\n        padding: 26px;\n        .alert__model__title{ \n        }\n        .alert__model__content{\n         color: #cccccc;\n        \n        }\n        .alert__model__close__icon{\n          width: 15px;\n          height: 15px;\n          right: 15px;\n          top: 8px;\n          cursor: pointer;\n          display: block;\n          img {width: 100%;height: 100%;}\n          svg{\n            font-size: 15px;\n            position: absolute;\n            top:-0.5px;\n            right: 1.5px;\n            color: rgba(255, 255, 255, 0.31);\n          }\n        }\n      }\n      &.ci{\n        height: 200px;\n        margin-top: -100px;\n        padding: 26px;\n        .alert__model__close__icon{\n          display: block;\n          width: 15px;\n          height: 15px;\n          right: 15px;\n          top: 8px;\n          cursor: pointer;\n          img {width: 100%;height: 100%;}\n          svg{\n            font-size: 15px;\n            position: absolute;\n            top:-0.5px;\n            right: 1.5px;\n          }\n        }\n      }\n  }\n  \n  .alert__model__title {\n    font-size: 21px;\n    text-align: center;\n  }\n  \n  .alert__model__content {\n    font-size: 16px;\n    text-align: center;\n    font-weight: 200;\n  }\n  \n  .alert__model__close__icon {\n    position: absolute;\n    right: 14px;\n    top: 14px;\n    color: gray;\n  }\n  \n  .confirm__model__actions {\n    text-align: center;\n    \n    > button {\n      margin: 0 5px -5px 5px;\n      background-color: transparent;\n      border: 1px ', ' solid;\n      color: ', ';\n      cursor: pointer;\n      padding: 3px 15px;\n    }\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactFontawesome = require('@fortawesome/react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _fontawesomeFreeSolid = require('@fortawesome/fontawesome-free-solid');

var _close = require('../assets/close.png');

var _close2 = _interopRequireDefault(_close);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var AlertModal = exports.AlertModal = (0, _styledComponents2.default)(function (props) {

  var overlay = {
    zIndex: 9999
  };

  if (props.profile == 'admin') {
    overlay.backgroundColor = 'rgba(27, 26, 41, 0.56)';
    overlay.top = '77.5px';
  } else {
    overlay.backgroundColor = 'rgba(255, 255, 255, 0.6)';
  }

  return _react2.default.createElement(
    _reactModal2.default,
    { isOpen: props.isOpen, className: props.className, style: { overlay: overlay }, __source: {
        fileName: _jsxFileName,
        lineNumber: 23
      },
      __self: undefined
    },
    _react2.default.createElement(
      'div',
      { className: 'alert__model__container ' + (props.profile === 'admin' ? 'admin' : 'ci'), __source: {
          fileName: _jsxFileName,
          lineNumber: 24
        },
        __self: undefined
      },
      _react2.default.createElement(
        'div',
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 25
          },
          __self: undefined
        },
        _react2.default.createElement(
          'a',
          { className: 'alert__model__close__icon', onClick: props.onCloseClicked, href: 'javascript:void(0)', __source: {
              fileName: _jsxFileName,
              lineNumber: 26
            },
            __self: undefined
          },
          _react2.default.createElement('img', { src: _close2.default, alt: '', __source: {
              fileName: _jsxFileName,
              lineNumber: 28
            },
            __self: undefined
          })
        ),
        _react2.default.createElement(
          'p',
          { className: 'alert__model__title', __source: {
              fileName: _jsxFileName,
              lineNumber: 30
            },
            __self: undefined
          },
          props.alertTitle
        ),
        _react2.default.createElement(
          'p',
          { className: 'alert__model__content', __source: {
              fileName: _jsxFileName,
              lineNumber: 33
            },
            __self: undefined
          },
          props.alertContent
        )
      )
    )
  );
})(_templateObject, function (props) {
  return props.profile == 'ci' ? '#ffffff' : 'rgba(14, 15, 25, 0.58)';
}, function (props) {
  return props.profile == 'ci' ? '1px #999999 solid' : '0.5px rgba(255, 255, 255, 0.56) solid';
}, function (props) {
  return props.profile == 'ci' ? '#000' : '#fff';
});

var ConfirmModal = exports.ConfirmModal = (0, _styledComponents2.default)(function (props) {

  var overlay = {
    zIndex: 9999
  };

  if (props.profile == 'admin') {
    overlay.backgroundColor = 'rgba(27, 26, 41, 0.56)';
    overlay.top = '77.5px';
  } else {
    overlay.backgroundColor = 'rgba(255, 255, 255, 0.6)';
  }

  var options = props.options,
      onOptionSelected = props.onOptionSelected;


  return _react2.default.createElement(
    _reactModal2.default,
    { isOpen: props.isOpen, className: props.className, style: { overlay: overlay }, __source: {
        fileName: _jsxFileName,
        lineNumber: 148
      },
      __self: undefined
    },
    _react2.default.createElement(
      'div',
      { className: 'alert__model__container ' + (props.profile === 'admin' ? 'admin' : 'ci'), __source: {
          fileName: _jsxFileName,
          lineNumber: 149
        },
        __self: undefined
      },
      _react2.default.createElement(
        'div',
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 150
          },
          __self: undefined
        },
        _react2.default.createElement(
          'a',
          { className: 'alert__model__close__icon', onClick: props.onCloseClicked, href: 'javascript:void(0)', __source: {
              fileName: _jsxFileName,
              lineNumber: 151
            },
            __self: undefined
          },
          _react2.default.createElement('img', { src: _close2.default, alt: '', __source: {
              fileName: _jsxFileName,
              lineNumber: 153
            },
            __self: undefined
          })
        ),
        _react2.default.createElement(
          'p',
          { className: 'alert__model__title', __source: {
              fileName: _jsxFileName,
              lineNumber: 155
            },
            __self: undefined
          },
          props.alertTitle
        ),
        _react2.default.createElement(
          'p',
          { className: 'alert__model__content', __source: {
              fileName: _jsxFileName,
              lineNumber: 158
            },
            __self: undefined
          },
          props.alertContent
        ),
        _react2.default.createElement(
          'div',
          { className: 'confirm__model__actions', __source: {
              fileName: _jsxFileName,
              lineNumber: 162
            },
            __self: undefined
          },
          options.map(function (i, key) {
            return _react2.default.createElement(
              'button',
              { key: key, onClick: function onClick(e) {
                  return onOptionSelected(i);
                }, __source: {
                  fileName: _jsxFileName,
                  lineNumber: 164
                },
                __self: undefined
              },
              i.label
            );
          })
        )
      )
    )
  );
})(_templateObject2, function (props) {
  return props.profile == 'ci' ? '#ffffff' : 'rgba(14, 15, 25, 0.85)';
}, function (props) {
  return props.profile == 'ci' ? '1px #999999 solid' : '0.5px rgba(255, 255, 255, 0.56) solid';
}, function (props) {
  return props.profile == 'ci' ? '#000' : '#fff';
}, function (p) {
  return p.profile == 'ci' ? '#999999' : 'rgba(255, 255, 255, 0.56)';
}, function (props) {
  return props.profile == 'ci' ? '#000' : '#fff';
});

var Context = _react2.default.createContext();

var Provider = exports.Provider = function (_Component) {
  _inherits(Provider, _Component);

  function Provider() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Provider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Provider.__proto__ || Object.getPrototypeOf(Provider)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  /**
   * Popup a confirm dialog
   * @param title
   * @param content
   * @param options
   */


  _createClass(Provider, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var modal = {
        alert: this.alert,
        confirm: this.confirm
      };

      var children = this.props.children;

      return _react2.default.createElement(
        _react2.default.Fragment,
        {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 363
          },
          __self: this
        },
        this.state.alertModal.messages.map(function (item, key) {
          return _react2.default.createElement(AlertModal, { isOpen: true,
            key: key,
            onCloseClicked: _this2.closeAlert,
            profile: _this2.props.profile,
            alertTitle: item.title,
            alertContent: item.content, __source: {
              fileName: _jsxFileName,
              lineNumber: 366
            },
            __self: _this2
          });
        }),
        this.state.confirmModal.messages.map(function (item, key) {
          return _react2.default.createElement(ConfirmModal, { isOpen: true,
            key: key,
            onCloseClicked: _this2.onConfirmCloseClicked,
            onOptionSelected: _this2.onConfirmOptionSelected,
            profile: _this2.props.profile,
            options: item.options,
            alertTitle: item.title,
            alertContent: item.content, __source: {
              fileName: _jsxFileName,
              lineNumber: 376
            },
            __self: _this2
          });
        }),
        _react2.default.createElement(
          Context.Provider,
          { value: modal, __source: {
              fileName: _jsxFileName,
              lineNumber: 386
            },
            __self: this
          },
          children
        )
      );
    }
  }]);

  return Provider;
}(_react.Component);

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.state = {
    alertModal: {
      messages: []
    },
    confirmModal: {
      messages: []
    } };

  this.confirm = function (_ref2) {
    var title = _ref2.title,
        content = _ref2.content,
        options = _ref2.options;

    _this5.setState({
      confirmModal: {
        messages: [{ title: title, content: content, options: options }]
      }
    });
  };

  this.alert = function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var title = '',
        content = '';

    if (args.length == 2) {
      title = args[0];
      content = args[1];
    } else if (args.length == 1) {
      if (typeof args[0] == 'string') {
        title = args[0];
      } else {
        title = args[0].title;
        content = args[0].content;
      }
    } else {
      throw new Error('Wrong parameters: ', args);
    }

    _this5.setState({
      alertModal: {
        messages: [{ title: title, content: content }]
      }
    });
  };

  this.closeAlert = function () {
    _this5.setState({
      alertModal: {
        messages: []
      }
    });
  };

  this.onConfirmCloseClicked = function () {
    _this5.setState({
      confirmModal: {
        messages: []
      }
    });
  };

  this.onConfirmOptionSelected = function (option) {
    _this5.setState({
      confirmModal: {
        messages: []
      }
    });
    option.action();
  };
};

var ModalProvider = exports.ModalProvider = Provider;

var withModal = exports.withModal = function withModal(WrappedComponent) {
  var WithModal = function (_Component2) {
    _inherits(WithModal, _Component2);

    function WithModal() {
      _classCallCheck(this, WithModal);

      return _possibleConstructorReturn(this, (WithModal.__proto__ || Object.getPrototypeOf(WithModal)).apply(this, arguments));
    }

    _createClass(WithModal, [{
      key: 'render',
      value: function render() {
        var _this4 = this;

        return _react2.default.createElement(
          Context.Consumer,
          {
            __source: {
              fileName: _jsxFileName,
              lineNumber: 404
            },
            __self: this
          },
          function (modal) {
            return _react2.default.createElement(WrappedComponent, Object.assign({}, _this4.props, { modal: modal, __source: {
                fileName: _jsxFileName,
                lineNumber: 405
              },
              __self: _this4
            }));
          }
        );
      }
    }]);

    return WithModal;
  }(_react.Component);

  WithModal.displayName = 'WithModal(' + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ')';


  return WithModal;
};


//////////////////
// WEBPACK FOOTER
// ../component-modal/dist/index.js
// module id = 323
// module chunks = 0